<div class="all-alerts-list-page">
    <avi-state-page>
        <avi-state-page_main-content>
            <avi-page-header
                headerText="{{ l10nKeys.headerLabel | vtranslate }}"
                [showTimeframeSelector]="true"
            ></avi-page-header>
            <avi-collection-data-grid
                [hideDelete]="true"
                [config]="alertCollectionGridConfig"
            ></avi-collection-data-grid>
        </avi-state-page_main-content>
    </avi-state-page>

    <ng-template
        #levelColorTemplateRef
        let-row
    >
        <cds-icon
            shape="circle"
            size="16"
            [status]="row.data.config.level | alertLevelColor"
            solid
        ></cds-icon>
        <label> {{ row.data.config.level | enumValueLabel : 'AlertLevel' }}</label>
    </ng-template>

    <ng-template
        #expandedContentTemplateRef
        let-row
    >
        <avi-diff-grid
            *ngIf="row.data.config.action_script_output"
            class="all-alerts-list-page__action-script-output_text"
            [rows]="getDiffGridRowsFromOutput(row.data.config.action_script_output)"
            [config]="actionScriptOutputGridConfig"
        ></avi-diff-grid>
        <avi-data-grid
                class="all-alerts-list-page__avi-data-grid"
                [config]="alertCaGridConfig"
                [rows]="[row]"
                [gridTitle]="l10nKeys.relatedAlertConfigLabel | vtranslate"
            ></avi-data-grid>
        <div
            *ngIf="row.data.config.events"
            class="all-alerts-list-page__config-alert"
        >
            <avi-data-grid
                class="all-alerts-list-page__avi-data-grid"
                [config]="alertEventsGridConfig"
                [rows]="row.data.config.events"
                [gridTitle]="l10nKeys.relatedEventsLabel | vtranslate : row.data.config.events.length"
            ></avi-data-grid>
        </div>
    </ng-template>

    <ng-template
        #expandedContentRelatedEventsTemplateRef
        let-row
    >
        <div
            *ngIf="row.data.config.event_details; else loader"
            class="all-alerts-list-page__related-event"
        >
            <ng-container *ngIf="row.data.config.event_description">
                <h5 class="all-alerts-list-page__sub-header">{{ globalL10nKeys.descriptionLabel | vtranslate }}</h5>
                <p class="all-alerts-list-page__sub-content">{{ row.data.config.event_description }}</p>
                <hr>
            </ng-container>
            <ng-container *ngTemplateOutlet="recursiveTemplate; context: { $implicit: row.data.config.event_details }"></ng-container>
        </div>

        <ng-template 
            #recursiveTemplate 
            let-data
        >
            <div *ngFor="let entry of data | keyvalue">
                <ng-container *ngIf="isPrimitive(entry.value); else nestedBlock">
                    <span class="all-alerts-list-page__key">{{ entry.key }}:</span>
                    {{ entry.value }}
                </ng-container>
                <ng-template #nestedBlock>
                    <div>
                        <span class="all-alerts-list-page__key">{{ entry.key }}:</span>
                        <div class="all-alerts-list-page__nested-property-block">
                            <ng-container
                                *ngTemplateOutlet="recursiveTemplate; context: { $implicit: entry.value }"
                            ></ng-container>
                        </div>
                    </div>
                </ng-template>
            </div>
        </ng-template>

        <ng-template #loader>
            <clr-spinner clrMedium></clr-spinner>
        </ng-template>
    </ng-template>
</div>
